import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationSaveImageVariationArgs,
  BackendSuggestionRequest,
} from 'src/types/backend';

import { FRAGMENT_SUGGEST_REQUEST } from './schema';

const MUTATION = gql`
  mutation SaveImageVariation($originalVariationId: ID!, $encodedImage: String!) {
    saveImageVariation(originalVariationId: $originalVariationId, encodedImage: $encodedImage) {
      ...SuggestionRequest
    }
  }
  ${FRAGMENT_SUGGEST_REQUEST}
`;

type Variables = BackendMutationSaveImageVariationArgs;
type Result = BackendSuggestionRequest;

export const saveImageVariation = async (variables: Variables) => {
  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(response.data);
};
